import { render, staticRenderFns } from "./LvAssignmentStartPage.vue?vue&type=template&id=a44540c0"
import script from "./LvAssignmentStartPage.vue?vue&type=script&lang=js"
export * from "./LvAssignmentStartPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports